/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import HeaderContainer from '../../common/HeaderContainer/HeaderContainer'
import { DropdownArrowIcon } from '../../../images/icons/DropdownArrow/DropdownArrow'
import Container from '../../common/Container/Container'
import { DefaultPicture } from '../../../images/icons/DefaultPicture/DefaultPicture'
import Tabs from '../../common/Tabs/Tabs'
import Widget from '../../common/Widget/Widget'
import ClientsTable from '../Clients/components/ClientsTable'
import ClientsTableHeader from '../Clients/components/ClientsTableHeader'
import AgencySummary from '../Dashboard/components/AgencySummary'
import ActivityTracker from '../Dashboard/components/ActivityTracker'
import PopUp from '../../common/PopUp/PopUp'
import RenewalsTable from '../Renewals/components/RenewalsTable'
import { Button } from '../../common/Button/Button'
import { get } from 'lodash'

import './styles/ManageAgencyDetail.css'

class ManageAgencyDetail extends React.Component<any, any> {

    constructor(props: any) {
        super(props)

        this.state = {
            agencySummaryTab: 'userStats',
            summarytimePeriod: '12 M',
            activityTrackertimePeriod: '12 M',
            activityTrackerData: [],
            selectorOpened: false,
            typeSelected: 'Agent',
            deactivatePopUp: false,
            deactivateWarningPopUp: false,
            activityTrackerDataTab: 'New policies',
            deactivateToId: null,
            renewPolicyPopUp: {
                show: false,
                renewId: '',
            },
            filters: {
                page: 1,
                perPage: 20,
                sortedBy: 'clientName',
                sortedType: 'asc',
            },
            filtersRenewal: {
                page: 1,
                perPage: 20,
                sortedBy: 'clientName',
                sortedType: 'asc',
            },
            agentAdminPopupData: {
                show: false,
                type: 'Agent',
                error: '',
            },
        }
    }

    componentWillMount() {
        this.props.fecthPoliciesList(undefined, undefined, undefined, undefined, this.props.match.params.id)
        this.props.fecthTrackerActivityTypes('newpolicies', this.props.match.params.id)
        this.props.fecthRenewalsList(undefined, undefined, undefined, undefined, this.props.match.params.id)
        this.props.fetchUsers()
        this.props.getUserDetail(this.props.match.params.id)
    }

    componentWillUnmount() {
        this.props.userDetail.done = false
    }

    componentWillUpdate(nextProps: any, nextState: any) {
        if (this.state.filters !== nextState.filters) {
            this.props.fecthPoliciesList(
                nextState.filters.page,
                nextState.filters.perPage,
                nextState.filters.sortedBy,
                nextState.filters.sortedType,
                this.props.match.params.id
            )
        }
        if (this.state.filtersRenewal !== nextState.filtersRenewal) {
            this.props.fecthRenewalsList(
                nextState.filtersRenewal.page,
                nextState.filtersRenewal.perPage,
                nextState.filtersRenewal.sortedBy,
                nextState.filtersRenewal.sortedType,
                this.props.match.params.id
            )
        }
    }

    /**
     * Will update the data if it receives a new one by props
     *
     * @param {*} nextProps
     * @memberof Dashboard
     */
    componentWillReceiveProps(nextProps: any) {
        const { changeUserType } = nextProps
        if (nextProps.activityTracker.response &&
            (nextProps.activityTracker.response.policiesMap !== this.state.activityTrackerData)) {
            this.setState({ activityTrackerData: nextProps.activityTracker.response.policiesMap })
        }
        if (nextProps.userDetail.done &&
            nextProps.userDetail.response &&
            nextProps.userDetail !== this.props.userDetail) {
            this.setState({ typeSelected: (nextProps.userDetail.response.user.agentAdmin) ? 'Admin' : 'Agent' })
        }
        if (changeUserType !== this.props.changeUserType) {
            this.setState({
                ...(changeUserType.done && changeUserType.response && {
                    typeSelected: get(changeUserType, 'response.agent_admin', false) ? 'Admin' : 'Agent',
                }),
                agentAdminPopupData: {
                    show: false,
                    type: '',
                    error: get(changeUserType, 'error', ''),
                },
            })
        }
    }

    changeAgencySummaryTabs = (event: any) => {
        if (event) {
            this.setState(
                {
                    agencySummaryTab: event.target.innerHTML
                        .replace(/\s(.)/g, function ($1: string) { return $1.toUpperCase() })
                        .replace(/\s/g, '')
                        .replace(/^(.)/, function ($1: string) { return $1.toLowerCase() }),
                }
            )
        }
    }

    changeType = (element) => {
        if (element !== this.state.typeSelected) {
            this.setState({ selectorOpened: false, agentAdminPopupData: { show: true, type: element } })
            // this.props.triggerAction(element)
        }
    }

    filterTrigger = (params: any) => this.setState(
        {
            filters: {
                page: this.state.filters.page,
                perPage: this.state.filters.perPage,
                sortedBy: params.sortedBy,
                sortedType: params.sortedType,
            },
        }
    )

    /**
     * Will fecth the new data of the ActivityTracker widget
     *
     * @memberof Dashboard
     */
    changeDataPoints = (event: any) => {
        if (event) {
            switch (event.target.innerHTML) {
                case 'New policies':
                    this.props.fecthTrackerActivityTypes('newpolicies')
                    this.setState({ activityTrackerDataTab: 'New policies' })
                    break

                case 'Quotes':
                    this.props.fecthTrackerActivityTypes('quotes')
                    this.setState({ activityTrackerDataTab: 'Quotes' })
                    break

                case 'NTU':
                    this.props.fecthTrackerActivityTypes('ntu')
                    this.setState({ activityTrackerDataTab: 'NTU' })
                    break

                case 'Renewals':
                    this.props.fecthTrackerActivityTypes('renewals')
                    this.setState({ activityTrackerDataTab: 'Renewals' })
                    break

                case 'Lapsed':
                    this.props.fecthTrackerActivityTypes('lapsed')
                    this.setState({ activityTrackerDataTab: 'Lapsed' })
                    break

                case 'All live policies':
                    this.props.fecthTrackerActivityTypes('livepolicies')
                    this.setState({ activityTrackerDataTab: 'All live policies' })
                    break

                default:
                    break
            }
        }
    }

    /**
     * Will change the period time to 3M 6M or 12M
     * It needs to have an event to avoid setState loops
     *
     * @memberof Dashboard
     * @param {*} event the event that calls the function
     */
    changeDataTimePeriod = (event: any) => {
        if (event) {
            switch (event.target.innerHTML) {
                case '12 M':
                    this.setState(
                        {
                            activityTrackertimePeriod: '12 M',
                        }
                    )
                    break
                case '6 M':
                    this.setState(
                        {
                            activityTrackertimePeriod: '6 M',
                        }
                    )
                    break
                case '3 M':
                    this.setState(
                        {
                            activityTrackertimePeriod: '3 M',
                        }
                    )
                    break

                default:
                    break
            }
        }
    }
    handleFooterClick = () => {
        this.setState({ filters: { perPage: this.state.filters.perPage + 20 } })
    }

    handleFooterClickRenewals = () => {
        this.setState({ filtersRenewal: { perPage: this.state.filtersRenewal.perPage + 20 } })
    }

    /**
     * Will add all the labels ad the bottom of the widget
     *
     * @memberof Dashboard
     */
    generateActivityTrackerLabels = () => {
        let labelList = [] as string[]

        if (this.state.activityTrackerData.length > 0) {
            switch (this.state.activityTrackertimePeriod) {
                case '12 M':
                    labelList = this.calculateMonth(this.state.activityTrackerData[2][0].date.split('-')[1], 12)

                    break

                case '6 M':
                    labelList = this.calculateMonth(this.state.activityTrackerData[1][0].date.split('-')[1], 6)

                    break

                case '3 M':
                    labelList = this.calculateMonth(this.state.activityTrackerData[0][0].date.split('-')[1], 3)

                    break

                default:
                    break
            }
        }

        return labelList.map((label, key) => {
            return (
                <div key={'label' + key}>{label}</div>
            )
        })
    }

    /**
     * Will change the period time to 3M 6M or 12M
     * It needs to have an event to avoid setState loops
     *
     * @memberof Dashboard
     * @param {*} event the event that calls the function
     */
    changeSummaryDataTimePeriod = (event: any) => {
        if (event) {
            switch (event.target.innerHTML) {
                case '12 M':
                    this.setState(
                        {
                            summarytimePeriod: '12 M',
                        }
                    )
                    break
                case '6 M':
                    this.setState(
                        {
                            summarytimePeriod: '6 M',
                        }
                    )
                    break
                case '3 M':
                    this.setState(
                        {
                            summarytimePeriod: '3 M',
                        }
                    )
                    break

                default:
                    break
            }
        }
    }

    /**
     * Will calculate all the bottom labels of the ActivityTracker widget from the data received
     * from the server. Will get the first month and calculate the following months depending on
     * the time period selected
     *
     * @memberof Dashboard
     * @param {number} month the first mont of the list
     * @param {number} numberOfMonths number of months to generate
     *
     */
    calculateMonth = (month: number, numberOfMonths: number) => {
        let activityTrackerLabels =
            ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        let finalArray = [] as string[]
        for (let i = (month - 1); i < (Number(month) + Number(numberOfMonths)) - 1; i++) {
            if (i >= 12) {
                finalArray.push(activityTrackerLabels[i - 12])
            } else {
                finalArray.push(activityTrackerLabels[i])
            }
        }
        return finalArray
    }

    openSelector = () => {
        this.setState({ selectorOpened: true })
    }

    showRenewPolicyPopUp = (state: any, newId: any) => {
        this.setState({
            renewPolicyPopUp: {
                show: state,
                renewId: newId,
            },
        })
    }

    handleDeactivateUser = (toId) => {
        // if (this.state.cancelPolicyPopUpTextArea !== '') {
        //     alert('Cancel policy request missing!')
        //     this.setState({ cancelPolicyPopUp: false, cancelPolicyPopUpTextAreaError: false })
        // } else {
        //     this.setState({ cancelPolicyPopUpTextAreaError: true })
        // }
        this.setState({ deactivatePopUp: false, deactivateToId: toId, deactivateWarningPopUp: true })
    }

    handleDeactivateUserClose = () => {
        this.setState({ deactivatePopUp: false })
    }

    render() {
        const { loading = false, error } = this.props.changeUserType
        if (this.props.userDetail.done && this.props.userDetail.response) {
            return (
                <div className="manageAencyDetail">

                    {
                        (this.state.deactivatePopUp) ?
                            <div
                                className=
                                {`deactivateUserPopUp ${(this.state.cancelPolicyPopUpTextAreaError) ? 'error' : ''}`}
                            >
                                <PopUp
                                    title="User de-activation"
                                    action={() => { this.handleDeactivateUserClose() }}
                                    buttonText="Cancel"
                                >
                                    <div className={`deactivateUserPopUpText`}>
                                        When deactivating a user, all the data must be moved to another user. Please
                                        select the user you want to move the data to:
                                    </div>
                                    <div className={`deactivateUserPopUpUsersList`}>
                                        {
                                            this.props.usersList.users.users.map((e) => {
                                                if (this.props.userDetail.response.user.id !== e.id) {
                                                    return <div
                                                        className={`deactivateUserPopUpUsersList__user`}
                                                        key={e.id}
                                                        onClick={() => this.handleDeactivateUser(e.id)}
                                                    >
                                                        <div
                                                            className={`deactivateUserPopUpUsersList__user--image`}
                                                        >
                                                            {(e.avatar) ?
                                                                <img
                                                                    src={e.avatar}
                                                                    alt="User photo"
                                                                /> :
                                                                <DefaultPicture />
                                                            }
                                                        </div>
                                                        <div className={`deactivateUserPopUpUsersList__user--name`}>
                                                            {e.firstName}
                                                        </div>
                                                    </div>
                                                } else {
                                                    return null
                                                }
                                            })
                                        }
                                    </div>
                                    <div className="errorText">
                                        A reason is required for canceling a policy
                                    </div>
                                </PopUp>
                            </div>
                            :
                            null
                    }

                    {
                        (this.state.deactivateWarningPopUp) ?
                            <div
                                className=
                                {`deactivateUserPopUp`}
                            >
                                <PopUp
                                    title="Are you sure?"
                                    action={() => {
                                        this.props.fetchDeactivateUser(
                                            this.props.userDetail.response.user.id,
                                            this.state.deactivateToId
                                        )
                                        this.setState({ deactivateWarningPopUp: false })
                                        this.props.history.push('/agent-admin/manage-agency')
                                    }}
                                    buttonText="Yes"
                                    secondaryAction={() => this.setState({ deactivateWarningPopUp: false })}
                                    secondaryButtonText="No"
                                >
                                    <div className={`deactivateUserPopUpText`}>
                                        You will send all the information to the new user!
                                    </div>
                                </PopUp>
                            </div>
                            :
                            null
                    }

                    {error && !loading && this.state.agentAdminPopupData.error ? (
                        < PopUp
                            title="User type changes error"
                            buttonText="Close"
                            action={() => {
                                this.setState({
                                    agentAdminPopupData: {
                                        error: '', show: false,
                                        type: '',
                                    },
                                })
                            }}
                        >
                            {error && typeof error === 'object'
                                ? Object.values(error).map((errMsg, index) => <div key={index}>{errMsg}</div>)
                                : 'An unexpected error occurred.'}
                        </ PopUp>
                    ) : null}

                    {loading ? (
                        <PopUp
                            title={`User type changes`}
                            buttonText={`Loading`}
                            action={() => { '' }}
                        >
                            ...loading
                        </ PopUp>
                    ) : null}

                    {
                        (this.state.agentAdminPopupData.show) ?
                            <div
                                className=
                                {`deactivateUserPopUp`}
                            >
                                <PopUp
                                    title="Are you sure?"
                                    action={() => {
                                        this.props.changeUserTypeAgency(
                                            this.props.userDetail.response.user.id,
                                            { role: this.state.agentAdminPopupData.type })
                                        this.setState({
                                            agentAdminPopupData: {
                                                show: false,
                                                type: '',
                                                error: '',
                                            },
                                        })
                                    }}
                                    buttonText="Yes"
                                    secondaryAction={() => this.setState({
                                        agentAdminPopupData: {
                                            show: false,
                                            type: '',
                                            error: '',
                                        },
                                    })}
                                    secondaryButtonText="No"
                                >
                                    <div className={`deactivateUserPopUpText`}>
                                        Are you sure you want to change the user type to <strong>
                                            {this.state.agentAdminPopupData.type}</strong>?
                                    </div>
                                </PopUp>
                            </div>
                            :
                            null
                    }
                    <HeaderContainer
                        className="quote__header"
                        fullwidth={true}
                        titles={[this.props.userDetail.response.user.fullName]}
                        image={this.props.userDetail.response.user.avatar}
                        back={true}
                        backAction={() => this.props.history.goBack()}
                    >
                        {
                            (!this.props.userDetail.response.user.agentAdmin) ?
                                <div
                                    className="deactivate_user"
                                    onClick={() => { this.setState({ deactivatePopUp: true }) }}
                                >
                                    De-activate user
                                </div>
                                :
                                null
                        }

                        <div className="subgroup">
                            {(this.props.sessionUser.userDetail.user.id !== this.props.userDetail.response.user.id) ?
                                <div className="subgroup__left">
                                    <div className="subgroup__left subgroup__left--text">
                                        User-type:
                                    </div>
                                    <div
                                        className="subgroup__left subgroup__left--selectable"
                                        onClick={() => { this.setState({ selectorOpened: true }) }}
                                    >
                                        <div>
                                            {this.state.typeSelected}
                                        </div>
                                    </div>
                                    <div
                                        className={`toggle ${(!this.state.selectorOpened) ?
                                            'hidden' :
                                            ''}`
                                        }
                                    >
                                        {
                                            ['Agent', 'Admin'].map((element, index) => (
                                                <div
                                                    key={index}
                                                    className={(this.state.typeSelected === element) ? 'selected' : ''}
                                                    onClick={() => { this.changeType(element) }}
                                                >
                                                    {element.charAt(0).toUpperCase() + element.slice(1)}
                                                </div>
                                            ))
                                        }
                                    </div>
                                    <div
                                        className="subgroup__left subgroup__left--dropdown"
                                        onClick={() => { this.setState({ selectorOpened: true }) }}
                                    >
                                        <DropdownArrowIcon />
                                    </div>
                                </div>
                                :
                                null
                            }
                            <div className="subgroup__right">
                                User since: {this.props.userDetail.response.user.since}
                            </div>
                        </div>
                    </HeaderContainer>
                    <div>
                        <Widget
                            className="agency-summary"
                            shadow={true}
                        >
                            <div className="widget__title widget__title--underline">
                                <h4>Agency summary</h4>
                            </div>
                            <Tabs
                                tabs={[
                                    {
                                        name: 'User stats', function: this.changeAgencySummaryTabs,
                                        position: 'left', selected: true,
                                    },
                                    {
                                        name: 'Agency stats', function: this.changeAgencySummaryTabs,
                                        position: 'left', selected: false,
                                    },
                                    {
                                        name: '12 M',
                                        function: this.changeSummaryDataTimePeriod,
                                        position: 'right',
                                        selected: true,
                                    },
                                    {
                                        name: '6 M',
                                        function: this.changeSummaryDataTimePeriod,
                                        position: 'right',
                                        selected: false,
                                    },
                                    {
                                        name: '3 M',
                                        function: this.changeSummaryDataTimePeriod,
                                        position: 'right',
                                        selected: false,
                                    },
                                ]}
                            />
                            <AgencySummary
                                fetchAgencySummary={() => { this.props.fetchAgencySummary(this.props.match.params.id) }}
                                agencySummary={this.props.agencySummary}
                                summarytimePeriod={
                                    this.state.summarytimePeriod === '12 M' ? 2 :
                                        (this.state.summarytimePeriod === '6 M') ? 1 : 0
                                }
                                tabSelected={this.state.agencySummaryTab}
                            />
                        </Widget>
                        <Widget
                            className="activity-tracker"
                            shadow={true}
                        >
                            <div className="widget__title widget__title--underline">
                                <h4>Activity tracker</h4>
                            </div>
                            <Tabs
                                tabs={[
                                    {
                                        name: 'New policies', function: this.changeDataPoints, position: 'left',
                                        selected: true,
                                    },
                                    {
                                        name: 'Quotes',
                                        function: this.changeDataPoints,
                                        position: 'left',
                                        selected: false,
                                    },
                                    { name: 'NTU', function: this.changeDataPoints, position: 'left', selected: false },
                                    {
                                        name: 'Renewals', function: this.changeDataPoints, position: 'left',
                                        selected: false,
                                    },
                                    {
                                        name: 'Lapsed',
                                        function: this.changeDataPoints,
                                        position: 'left',
                                        selected: false,
                                    },
                                    {
                                        name: 'All live policies', function: this.changeDataPoints,
                                        position: 'left', selected: false,
                                    },
                                    {
                                        name: '12 M', function: this.changeDataTimePeriod, position: 'right',
                                        selected: true,
                                    },
                                    {
                                        name: '6 M', function: this.changeDataTimePeriod, position: 'right',
                                        selected: false,
                                    },
                                    {
                                        name: '3 M', function: this.changeDataTimePeriod, position: 'right',
                                        selected: false,
                                    },
                                ]}
                            />
                            <ActivityTracker
                                data={this.state.activityTrackerData[
                                    (this.state.activityTrackertimePeriod === '12 M') ?
                                        2 :
                                        ((this.state.activityTrackertimePeriod === '6 M') ?
                                            1 :
                                            0)
                                ]}
                                chartWidth={940}
                                chartHeight={360}
                                margin={{ top: 90, right: 0, left: 0, bottom: 0 }}
                                horizontalGrid={false}
                                verticalGrid={true}
                                activityTrackerDataTab={this.state.activityTrackerDataTab}
                                verticalGridLines={(this.state.activityTrackertimePeriod === '12 M') ?
                                    11 :
                                    ((this.state.activityTrackertimePeriod === '6 M') ?
                                        5 :
                                        2)}
                                horizontalGridLines={(this.state.activityTrackertimePeriod === '12 M') ?
                                    11 :
                                    ((this.state.activityTrackertimePeriod === '6 M') ?
                                        5 :
                                        2)}
                            />
                            <div className="activity-tracker__footer">
                                {this.generateActivityTrackerLabels()}
                            </div>
                        </Widget>
                        <Widget
                            className="your-quotes"
                            shadow={true}
                        >
                            <div className="widget__title widget__title--underline">
                                <h4>Your policies</h4>
                            </div>
                            <div className="your-quotes__content">
                                <Container className="clients clients__table table__content" fullwidth={false}>
                                    <ClientsTableHeader
                                        dataType="policies"
                                        state={this.state}
                                        filterTrigger={this.filterTrigger}
                                    />
                                    <ClientsTable
                                        clientList={this.props.clientList}
                                        dataType="policies"
                                        confirmEditQuote={this.props.confirmEditQuote}
                                        history={this.props.history}
                                        manageAgency={true}
                                        bindClick={
                                            (quote, variation) => {
                                                this.setState(
                                                    {
                                                        bindPopUp: {
                                                            show: true,
                                                            quoteId: quote.id,
                                                            quoteVariationId: variation.id,
                                                            businessName: quote.clientName,
                                                            quoteRef: variation.quoteRef,
                                                            inceptionDate: quote.inceptionDate,
                                                            printDate: quote.quotedDate,
                                                            premium: variation.premium,
                                                            commission: variation.commission,
                                                            excess: variation.excess,
                                                        },
                                                    }
                                                )
                                            }
                                        }
                                    />
                                    <Button onClick={this.handleFooterClick}>Load more</Button>
                                </Container>
                            </div>
                        </Widget>
                        <Widget
                            className="your-quotes"
                            shadow={true}
                        >
                            <div className="widget__title widget__title--underline">
                                <h4>Your renewals</h4>
                            </div>
                            <div className="your-quotes__content">
                                <Container className="clients clients__table table__content" fullwidth={false}>
                                    <RenewalsTable
                                        renewalsList={
                                            (this.props.renewals.done && this.props.renewals.response.future) ?
                                                this.props.renewals.response.future :
                                                []
                                        }
                                        dataType="futureRenewals"
                                        manageAgency={true}
                                        showRenewPolicyPopUp={this.showRenewPolicyPopUp}
                                    />
                                    <Button onClick={this.handleFooterClickRenewals}>Load more</Button>

                                </Container>
                            </div>
                        </Widget>
                    </div>
                </div>
            )
        } else {
            return <div />
        }

    }
}

export default ManageAgencyDetail



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/ManageAgency/ManageAgencyDetail.tsx